import { Box } from '@mui/material';
import { useInvoiceSummaryFromParams } from 'src/use-cases/invoice/useInvoices';
import { useShipmentSelector } from '../ShipmentSelector';
import TransportSummary from './transportSummary';
import LegCard from './Legcard';

const LegDetails = () => {
  const { data: invoiceSummary } = useInvoiceSummaryFromParams();
  const { shipment } = useShipmentSelector();
  const invoiceId = invoiceSummary?.id;
  const data = shipment.legDetails || [];

  return (
    <>
      {shipment?.transportDetail && (
        <div className='mb-24'>
          <TransportSummary data={shipment} />
        </div>
      )}
      <Box className='grid-cols-3 gap-10 grid w-full'>
        {['LEG_ONE', 'LEG_TWO', 'LEG_THREE'].map((type, index) => {
          const legDetail = data.find((detail) => detail.type === type) || {};

          return <LegCard key={type} legDetail={legDetail} index={index} invoiceId={invoiceId} />;
        })}
      </Box>
    </>
  );
};

export default LegDetails;
